<template>
  <div style="margin: -24px">
    <iframe :src="url" frameborder="0"></iframe>
  </div>
</template>
<script>
const domain = "https://"+window.location.host
export default {
  data(){
    return {
      url: domain+"/h5/big-screen/index.html"
    }
  }
}
</script>
<style lang="less" scoped>
iframe {
  width: 100%;
  height: calc(100vh - 65px);
}
</style>